import type React from 'react'
import {Button as PepsicoButton} from 'pepsico-ds'

// Using interface instead of type to allow extension
export interface ButtonProps {
  // Core props
  text?: string
  variant?:
    | 'primary'
    | 'secondary'
    | 'auxiliary'
    | 'tertiary'
    | 'danger'
    | 'primaryInverse'
    | 'secondaryInverse'
    | 'auxiliaryInverse'
    | 'tertiaryInverse'
    | 'dangerInverse'
  size?: 'small' | 'medium' | 'large'
  disabled?: boolean
  isLoading?: boolean

  // Icon props
  iconLeading?: string
  iconTrailing?: string

  // Theme prop removed as it's no longer supported

  // Event handlers
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void

  // Children elements
  children?: React.ReactNode

  // Any other HTML button props
  [key: string]: any
}

const Button: React.FC<ButtonProps> = ({
  // Core props
  text,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  isLoading = false,

  // Icon props
  iconLeading,
  iconTrailing,

  // Theme prop removed

  // Event handlers
  onClick,

  // Children elements
  children,

  // Rest of props
  ...rest
}) => {
  // Theme handling removed

  return (
    <PepsicoButton
      text={text}
      variant={variant}
      size={size}
      disabled={disabled}
      isLoading={isLoading}
      iconLeading={iconLeading}
      iconTrailing={iconTrailing}
      onClick={onClick}
      className="select-none"
      {...rest}
    >
      {children}
    </PepsicoButton>
  )
}

export default Button
